import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useToast } from "@/context/ToastContext";
import { useAuth } from "@/context/AuthContext";
import { Loader, Currency, Field } from "@/components/Atoms";
import {
  Shield, Users, Crown, Coins, Settings, Wrench, Ban, ScrollText, Map as MapIcon,
  UserCog, Layers, Gift, PackageOpen, Server, Lock, KeyRound, Flame, Calendar,
  Flag, Sparkles, RefreshCw
} from "lucide-react";



export function WebUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const load = () => api.get("/admin/web-users").then(({ data }) => setUsers(data.users || [])).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);
  const toggle = async (u) => {
    try {
      await api.put(`/admin/web-users/${u.id}/admin?is_admin=${!u.is_admin}`);
      toast.success("Updated");
      load();
    } catch (e) { toast.error(apiError(e)); }
  };
  if (loading) return <Loader />;
  return (
    <>
    {/* Phones: card list; the table below takes over from sm upward. */}
    <ul className="glass-card divide-y divide-white/5 sm:hidden fade-up" data-testid="web-users-list-mobile">
      {users.map((u) => (
        <li key={`m-${u.id}`} className="p-3 space-y-1.5">
          <div className="flex items-center justify-between gap-2">
            <span className="truncate">{u.email || u.discord_username || u.id}</span>
            <button onClick={() => toggle(u)} className="btn btn-sm btn-secondary shrink-0" data-testid={`toggle-admin-m-${u.id}-button`}>Toggle</button>
          </div>
          <div className="flex items-center gap-2 text-xs text-[var(--muted)]">
            {u.is_admin
              ? <span className="badge text-[var(--warning)] border-[var(--warning)]">Admin</span>
              : <span>Standard</span>}
            <span className="truncate">{u.created_at}</span>
          </div>
        </li>
      ))}
      {users.length === 0 && <li className="p-6 text-center text-[var(--muted)]">No users.</li>}
    </ul>

    <div className="glass-card overflow-x-auto fade-up hidden sm:block">
      <table className="w-full text-sm">
        <thead className="text-[10px] uppercase tracking-wider text-[var(--muted)]">
          <tr><th className="text-left p-3">Email / Discord</th><th className="text-left p-3">Joined</th><th className="text-left p-3">Admin</th><th className="p-3"></th></tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id} className="border-t border-white/5">
              <td className="p-3">{u.email || u.discord_username || u.id}</td>
              <td className="p-3 text-[var(--muted)]">{u.created_at}</td>
              <td className="p-3">{u.is_admin ? <span className="badge text-[var(--warning)] border-[var(--warning)]">Admin</span> : "—"}</td>
              <td className="p-3 text-right"><button onClick={() => toggle(u)} className="btn btn-sm btn-secondary" data-testid={`toggle-admin-${u.id}-button`}>Toggle</button></td>
            </tr>
          ))}
          {users.length === 0 && <tr><td colSpan={4} className="p-6 text-center text-[var(--muted)]">No users.</td></tr>}
        </tbody>
      </table>
    </div>
    </>
  );
}
